import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { ToolbarTitle } from 'material-ui/Toolbar'

const CustomToolbarTitle = muiThemeable()(
  ({
    primary,
    muiTheme: {
      palette: {
        alternateTextColor,
      },
    },
    ...props,
  }) => {
    return (
      <ToolbarTitle
        style={{
          fontSize: 18,
          color: primary ? alternateTextColor : '',
        }}
        {...props}
      />
    )
  }
)

CustomToolbarTitle.propTypes = {
  primary: PropTypes.bool,
}
CustomToolbarTitle.defaultProps = {
  primary: false,
}

export default CustomToolbarTitle



// WEBPACK FOOTER //
// ./src/components/bars/CustomToolbarTitle.js